import React, { useState } from 'react';

const StatusToggle = ({ status = false, onChange }) => {
  return (
    <div
      onClick={() => onChange(!status)}
      className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-all duration-300 ${
        status ? "bg-green-500" : "bg-gray-400"
      }`}
    >
      <div
        className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${
          status ? "translate-x-6" : "translate-x-0"
        }`}
      ></div>
    </div>
  );
};

export default StatusToggle;
